import localStorageUtility from 'common/utility/localStorageUtility';
import { riskIntelligenceTranslations } from 'translations';



const riAccountInfo = localStorageUtility.getData('riAccountInfo');
const riConfigurationInfo = localStorageUtility.setData('riConfigurationInfo');

export const tilesConfig = [
    {
        title: riskIntelligenceTranslations.ng_common_admin,
        description: riskIntelligenceTranslations.ng_common_admin,
        path: '/account',
        visible: access => !!riAccountInfo
    },
    {
        title: riskIntelligenceTranslations.ng_common_communicationMethods,
        description: riskIntelligenceTranslations.ng_common_communicationMethods,
        path: '/communication-methods',
        visible: access => !!riAccountInfo
    },
    {
        title: riskIntelligenceTranslations.ng_common_filters,
        description: riskIntelligenceTranslations.ng_common_filters,
        path: '/filters',
        visible: access => !!riAccountInfo
    },
    {
        title: riskIntelligenceTranslations.ng_common_travel,
        description: riskIntelligenceTranslations.ng_common_travel,
        path: '/travel',
        visible: access => riConfigurationInfo?.travel
    }
];
